import React, { Component } from 'react';
import axios from '~/data/http/axios';
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import CheckBox from '~/Common-Objects/UI/Forms/CheckBox/CheckBox'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import TierLimitHolder from '~/Common-Objects/UI/Cards/TierLimitHolder'
import EmailTools from '~/Classes/emailValidator';
import i18n from '~/i18n';
class AddMailbox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            mailbox: undefined,
            processing: false,
            error: '',
            connectionType: '',
            tierErrored: false,
            tierPermissions: {},
            inputErrors: {
                emailAddress: '',
                user: '',
                password: '',
                host: '',
                port: ''
            }
        }
        this.updateValue = this.updateValue.bind(this)
        this.validate = this.validate.bind(this)
        this.save = this.save.bind(this)
    }

    componentDidMount() {
        if (this.props.mailbox) {
            this.setState({
                mailbox: this.props.mailbox,
                loading: false
            })
        } else {
            this.setState({
                mailbox: {
                    emailAddress: '',
                    user: '',
                    password: '',
                    host: '',
                    port: 993,
                    tls: true,

                },
                loading: false
            })
        }
    }

    updateValue(ev) {
        var mailbox = { ...this.state.mailbox }
        mailbox[ev.currentTarget.name] = ev.currentTarget.type === 'checkbox' ? ev.currentTarget.checked : ev.currentTarget.value
        var inputErrors = { ...this.state.inputErrors }
        if (inputErrors[ev.currentTarget.name]) {
            inputErrors[ev.currentTarget.name] = ''
        }
        this.setState({ mailbox, inputErrors })
    }

    validate() {
        const { mailbox } = this.state
        const inputErrors = {
            emailAddress: '',
            user: '',
            password: '',
            host: '',
            port: ''
        }
        let failed = false
        const emailAddress = (mailbox.emailAddress || '').trim()

        if (!emailAddress) {
            inputErrors.emailAddress = i18n.t('company:mailboxes.emailRequired')
            failed = true
        } else if (!EmailTools.validateEmail(emailAddress)) {
            inputErrors.emailAddress = i18n.t('company:mailboxes.invalidEmail')
            failed = true
        }

        if (!(mailbox.user || '').trim()) {
            inputErrors.user = i18n.t('company:mailboxes.requiredField')
            failed = true
        }

        if (!mailbox.id && !(mailbox.password || '').trim()) {
            inputErrors.password = i18n.t('company:mailboxes.requiredField')
            failed = true
        }

        if (!(mailbox.host || '').trim()) {
            inputErrors.host = i18n.t('company:mailboxes.requiredField')
            failed = true
        }

        const port = mailbox.port
        if (port === '' || port === null || port === undefined) {
            inputErrors.port = i18n.t('company:mailboxes.requiredField')
            failed = true
        } else if (isNaN(parseInt(port, 10)) || parseInt(port, 10) <= 0) {
            inputErrors.port = i18n.t('company:mailboxes.invalidPort')
            failed = true
        }

        this.setState({ inputErrors })
        return !failed
    }

    save() {
        if (!this.validate()) {
            return
        }

        this.setState({
            processing: true,
            error: ''
        })
        var promise;
        if (this.state.mailbox.id) {
            promise = axios.put('/accountMaster/mailbox/' + this.state.mailbox.id, this.state.mailbox)
        } else {
            promise = axios.post('/accountMaster/mailbox', this.state.mailbox)
        }
        promise.then(() => {
            this.setState({
                processing: false
            })
            this.props.finish()
        }).catch(err => {
            console.log(err);
            if (this.state.mailbox.id) {
                this.setState({
                    processing: false,
                    error: err.data.error,
                    tierErrored: false
                })
            }
            else {
                if (err && err.data && err.data.error && err.data.error.tierName) {
                    this.setState({ processing: false, error: "", tierPermissions: err.data.error, tierErrored: true, loading: false })
                } else if (err && err.data && err.data.error && typeof err.data.error == "string") {
                    this.setState({ processing: false, error: err.data.error, tierErrored: false, loading: false })
                }
            }

        })
    }

    render() {
        if (this.state.loading) return <LoadingIcons iconType="2" />
        if (this.state.tierErrored) return <TierLimitHolder type="Mailbox" err={this.state.tierPermissions.err} allowedNumber={this.state.tierPermissions.allowedNumber} tierName={this.state.tierPermissions.tierName} />
        return (
            <div>
                <h4 className="mar-b25">{this.state.mailbox.id ? i18n.t('company:mailboxes.update') : i18n.t('company:mailboxes.add')} {i18n.t('company:mailboxes.mailbox')}</h4>
                <div className="mar-b25">{i18n.t('company:mailboxes.imapSettings')}</div>
                <TextInput outerClassName="mar-b20" label={i18n.t('company:mailboxes.emailAddress')} value={this.state.mailbox.emailAddress} name="emailAddress" placeholder={i18n.t('company:mailboxes.emailAddress')} type="email" error={this.state.inputErrors.emailAddress} onChange={this.updateValue} />
                <TextInput outerClassName="mar-b20" label={i18n.t('company:mailboxes.imapUserName')} value={this.state.mailbox.user} name="user" placeholder={i18n.t('company:mailboxes.imapUserName')} type="text" error={this.state.inputErrors.user} onChange={this.updateValue} />
                <TextInput outerClassName="mar-b20" label={i18n.t('company:mailboxes.imapPassword')} value={this.state.mailbox.password} name="password" placeholder={i18n.t('company:mailboxes.imapPassword')} type="password" error={this.state.inputErrors.password} onChange={this.updateValue} />
                <TextInput outerClassName="mar-b20" label={i18n.t('company:mailboxes.imapHost')} value={this.state.mailbox.host} name="host" placeholder="mail.yourdomain.com" type="text" error={this.state.inputErrors.host} onChange={this.updateValue} />
                <TextInput outerClassName="mar-b20" label={i18n.t('company:mailboxes.imapHostPort')} value={this.state.mailbox.port} name="port" placeholder="993" type="number" error={this.state.inputErrors.port} onChange={this.updateValue} />
                <CheckBox outerClassName="mar-b25" checked={this.state.mailbox.tls} onChange={this.updateValue} name="tls">{i18n.t('company:mailboxes.isTLSEnabled')}</CheckBox>
                <div className="quickFlex">
                    <Button className="button-primary mar-r10" saving={this.state.processing} text={i18n.t('company:mailboxes.save')} onClick={this.save} />
                    <Button text={i18n.t('company:mailboxes.cancel')} disabled={this.state.processing} onClick={this.props.cancel} />
                </div>
                {!!this.state.error && !this.state.processing && <div className="text-red text-heavy mar-t10">{this.state.error}</div>}
            </div>
        );
    }
}

export default AddMailbox;